import React, { useState, useRef } from "react"; // <-- Import ให้ครบ

// รับ ...props เพื่อให้ส่ง data-sound-ignore เข้ามาได้
export default function HoldToConfirmButton({
  onConfirm,
  holdTime = 1500,
  children,
  className,
  disabled,
  ...props
}) {
  const [isHolding, setIsHolding] = useState(false);
  const timerRef = useRef(null);
  const holdDuration = holdTime;

  const handlePressStart = (e) => {
    if (disabled) return;
    // Fix: Remove e.preventDefault() to avoid "passive event listener" error
    // "touch-action: none" in style already prevents scrolling.
    e.stopPropagation();

    setIsHolding(true);
    timerRef.current = setTimeout(() => {
      onConfirm();
      setIsHolding(false);
      timerRef.current = null;
    }, holdDuration);
  };

  const handlePressEnd = (e) => {
    if (e) e.preventDefault();
    if (disabled || !timerRef.current) return;
    clearTimeout(timerRef.current);
    timerRef.current = null;
    setIsHolding(false);
  };

  return (
    <button
      {...props} // <-- กระจาย props ที่เหลือลงไป (รวมถึง data-sound-ignore)
      onMouseDown={handlePressStart}
      onMouseUp={handlePressEnd}
      onMouseLeave={handlePressEnd}
      onTouchStart={handlePressStart}
      onTouchEnd={handlePressEnd}
      onContextMenu={(e) => {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }}
      onDragStart={(e) => {
        e.preventDefault();
      }}
      disabled={disabled}
      style={{
        WebkitTouchCallout: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none",
        touchAction: "none",
        outline: "none",
      }}
      className={`relative overflow-hidden ${className} transition-all duration-100 active:scale-95 active:shadow-inner select-none cursor-pointer`}
    >
      <span
        className={`absolute inset-y-0 left-0 bg-white/30 transition-transform pointer-events-none ${
          isHolding ? "scale-x-100" : "scale-x-0"
        }`}
        style={{
          width: "100%",
          transformOrigin: "left",
          transitionTimingFunction: "linear",
          transitionDuration: isHolding ? `${holdDuration}ms` : "200ms",
        }}
      ></span>
      <span className="relative z-10 pointer-events-none">{children}</span>
    </button>
  );
}
